import { createApiClient } from '../../../api/apiClient';
import { SYSTEM_REST_API_BASE_URL } from '../../../config';
const REST_API_BASE_URL = SYSTEM_REST_API_BASE_URL;

// Dedicated instance so the error-handling interceptor below doesn't affect
// other service calls that use the shared apiClient singleton.
const axiosInstance = createApiClient();

axiosInstance.interceptors.response.use(
  (response) => {
    // Hide loading message
    console.log('Request completed');

    // Return the response to be handled by the .then() method
    return response;
  },
  (error) => {
    // Hide loading message on error
    console.log('Request failed');

    if (error.response && error.response.status === 403) {
      // Handle 403 error: Session expired
      alert('Session has expired. Please log in again.');
      alert(error.response);
      alert(error.response.message);
      alert(error.response.status);

      // Clear the token and other relevant data
      //logout();

      // Redirect to login page
      //window.location.href = '/login';
    }

    // Handle other response errors
    return Promise.reject(error);
  },
);

export const saveDiscountCode = (discountCode) =>
  axiosInstance.post(`${REST_API_BASE_URL}/discount-codes`, discountCode);

export const applyDiscountCode = (discountCode) =>
  axiosInstance.post(
    `${REST_API_BASE_URL}/account/cart/apply-discount-code?discountCode=${discountCode}`,
  );

export const removeDiscountCode = () =>
  axiosInstance.post(`${REST_API_BASE_URL}/account/cart/remove-discount-code`);

export const createCheckoutOrder = () =>
  axiosInstance.post(`${REST_API_BASE_URL}/account/checkout`);

export const getProfileRole = () =>
  axiosInstance.post(`${REST_API_BASE_URL}/profile/role`);

// export const saveShippingDetails = (shippingDetails ) => axiosInstance.post(`${REST_API_BASE_URL}/account/shipping-address`, shippingDetails);

// export const getShippingDetails = () => axiosInstance.get(`${REST_API_BASE_URL}/account/shipping-address`);

// export const updateShippingAddress = (shippingDetails ) => axiosInstance.post(`${REST_API_BASE_URL}/account/update-shipping`, shippingDetails);

// export const saveBillingAddress = (billingDetails ) => axiosInstance.post(`${REST_API_BASE_URL}/account/savebillingaddress`, billingDetails);

// export const getBillingAddress = () => axiosInstance.get(`${REST_API_BASE_URL}/account/billingaddress`);

export const saveBillingAddress = (billingDetails) =>
  axiosInstance.post(
    `${REST_API_BASE_URL}/account/save-billingaddress`,
    billingDetails,
  );

export const getBillingAddress = () =>
  axiosInstance.get(`${REST_API_BASE_URL}/account/billingaddress`);

export const updateBillingAddress = (billingDetails) =>
  axiosInstance.post(
    `${REST_API_BASE_URL}/account/update-billingaddress`,
    billingDetails,
  );

export const getOrderSummary = () =>
  axiosInstance.get(`${REST_API_BASE_URL}/account/cart-order-summary`);

export const getCartItems = () =>
  axiosInstance.get(`${REST_API_BASE_URL}/account/cart-items`);

export default axiosInstance;
